import logo from '@/static/img/logotipo_bitono.svg';
import reversedLogo from '@/static/img/logotipo_invertido.svg';

export const IS_DEV = process.env.NODE_ENV === 'development';
// En local debe ser true para pausar Google Analytics durante las pruebas
export const IS_LOCAL_TEST = false;
export const DEV_BASE_DOMAIN =
  'https://besafer.development.hispatecanalytics.com';

export const PROD_BASE_DOMAIN =
  'https://besafer.privatecloud.hispatecanalytics.com';
export const DEFAULT_LANGUAGE = 'es';
export const APP_LOGO = logo;
export const APP_LOGO_REVERSED = reversedLogo;
export const APP_NAME = 'Besafer 4.0';
export const SECONDARY_COLOR = '#85bb23';
export const SEPARATOR = '$[]$';
export const ATCS_ES = {
  agronomy: 'Agronomía',
  environment: 'Medio Ambiente',
  food: 'Alimentaria',
  mining: 'Minería',
  healthSecurity: 'Salud y Seguridad',
};
export const ATCS_TRANSLATED = {
  Agronomy: 'Agronomy',
  Food: 'Food',
  Environment: 'Environment',
  Mining: 'Mining',
  'Health and Security': 'Health and Security',
};
export const REQUEST_TIME = '600000';
export const UE_COUNTRIES = ['ES', 'IT', 'FR', 'PT'];
export const ALL_LANGUAGES = [
  { key: 'ENG', value: 'en' },
  { key: 'SPA', value: 'es' },
  { key: 'FRA', value: 'fr' },
  { key: 'POR', value: 'pt' },
  { key: 'ITA', value: 'it' },
];
export const POWERBI_REPORTS = [
  {
    key: 'Alimentaria',
    reportId: '3bab88de-e8cd-49e9-a258-e705a61f7dea',
    datasetId: '8a18b362-79a7-441f-9741-870cd1bb8eee',
  },
  {
    key: 'Agronomía',
    reportId: 'd8024169-c617-41d5-8dd0-0cf82adf0fff',
    datasetId: '06f78509-0f97-4a51-afe8-7ccf45a92f04',
  },
  {
    key: 'Medio Ambiente',
    reportId: '',
    datasetId: '',
  },
];
export const AFTER_DATE_LIMIT = '2019-01-01';
export const NOTIFY_TIME_LONG = 7000;
export const NOTIFY_TIME_LONGER = 20000;
export const ENABLE_INFO_POPUP = false;
export const ENABLE_AGROIA_GUIDED_TOUR = true;
export const AGROIA_GUIDED_TOUR_STORAGE_KEY = 'agroia-guided-tour-v1';
export const AGROIA_GUIDED_TOUR_AUTO_START_DELAY = 600;
export const AGROIA_GUIDED_TOUR_RESHOW_INTERVAL_DAYS = 14;
export const AGROIA_GUIDED_TOUR_MAX_AUTO_SHOWS_WITHOUT_COMPLETION = 3;
export const AGROIA_GUIDED_TOUR_MAX_IN_PROGRESS_AUTO_RESHOWS = 2;
export const ENABLE_SAMPLES_REGISTER_GUIDED_TOUR = true;
export const SAMPLES_REGISTER_GUIDED_TOUR_STORAGE_KEY =
  'samples-register-guided-tour-v1';
export const SAMPLES_REGISTER_TEMPLATES_GUIDED_TOUR_STORAGE_KEY =
  'samples-register-templates-guided-tour-v1';
export const SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY = 900;
export const SAMPLES_REGISTER_GUIDED_TOUR_RESHOW_INTERVAL_DAYS = 14;
export const SAMPLES_REGISTER_GUIDED_TOUR_MAX_AUTO_SHOWS_WITHOUT_COMPLETION = 3;
export const SAMPLES_REGISTER_GUIDED_TOUR_MAX_IN_PROGRESS_AUTO_RESHOWS = 2;
export const ENABLE_ISSUED_INVOICES_GUIDED_TOUR = true;
export const ISSUED_INVOICES_GUIDED_TOUR_STORAGE_KEY =
  'issued-invoices-guided-tour-v1';
export const ISSUED_INVOICES_GUIDED_TOUR_AUTO_START_DELAY = 900;
export const ISSUED_INVOICES_GUIDED_TOUR_RESHOW_INTERVAL_DAYS = 14;
export const ISSUED_INVOICES_GUIDED_TOUR_MAX_AUTO_SHOWS_WITHOUT_COMPLETION = 3;
export const ISSUED_INVOICES_GUIDED_TOUR_MAX_IN_PROGRESS_AUTO_RESHOWS = 2;
export const baseUrlPre =
  'besafer.privatecloud.hispatecanalytics.com'; // Endpoint pre para websocket
export const NOTIFICATION_WEBSOCKET_URL = baseUrlPre.replace(
  /^http/,
  'ws'
);
export const ALLOWED_SAMPLES_PARAMETERS = 250;
export const RELEASE_VERSION = '3.0.0';

// TEMP_BLOQUEO_EDITAR_MUESTRA
export const ENABLE_TEMP_SAMPLE_EDIT_LOCK = false;
